import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getContent, getErrorMessage } from '../../../util/responseUtil';
import { CheckPermissionComponent } from '../../../util/permission';
import { PROFILE_CHANGE_PASSWORD_UPDATE, PROFILE_USER_VIEW } from '../../../constants/menuPermissionConstant';
import ActionType from '../../../redux/reducer/globalActionType';
import API_AUTHENTICATION from '../../../api/apiAuthentication';
import BackButton from '../../../components/Common/BackButton';
import IconClosedEye from '../../../assets/icons/IconClosedEye';
import IconOpenedEye from '../../../assets/icons/IconOpenedEye';
import Alert from '../../../components/Alert/Alert';

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            image: '',
            showPassword1: false,
            showPassword2: false,
            showPassword3: false,
            showUploadModal: false,
            firstName: '',
            lastName: '',
            oldPassword: '',
            newPassword: '',
            verifyNewPassword: '',
            showSuccessAlert1: false,
            showSuccessAlert2: false,
            showErrorAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    removeAttribute = e => {
        e.target.removeAttribute('readonly')
    }

    onImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.setState({ image: e.target.result });
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    getUserDetail = () => {
        const detailUser = {
            username: this.props.userDetail.username
        }

        API_AUTHENTICATION.postDetailUser(detailUser, this.props.token)
            .then(res => {
                this.props.handleLogin(getContent(res))
            })
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleChangeName = e => {
        e.preventDefault();

        const data = {
            first_name: this.state.firstName,
            last_name: this.state.lastName,
            updated_at: this.props.userDetail.updated_at
        }

        const id = this.props.userDetail.nexcare_id

        API_AUTHENTICATION.putChangeName(data, id, this.props.token)
            .then(res => {
                this.setState({ showSuccessAlert1: true })
                setTimeout(() => {
                    this.setState({ showSuccessAlert1: false })
                    this.getUserDetail()
                }, 1500)
            }).catch(err => {
                this.setState({ errorMessage: getErrorMessage(err) })
                this.setState({ showErrorAlertResponse: true })
            })
    }

    handleChangePassword = e => {
        e.preventDefault();

        if (this.state.oldPassword === this.state.newPassword) {
            return this.setState({ showErrorAlert: true })
        }

        const data = {
            user_id: this.props.userDetail.user_id,
            old_password: this.state.oldPassword,
            new_password: this.state.newPassword,
            verify_new_password: this.state.verifyNewPassword
        }

        API_AUTHENTICATION.postChangePassword(data, this.props.token)
            .then(res => {
                this.setState({ showSuccessAlert2: true })
                setTimeout(() => {
                    this.setState({
                        showSuccessAlert2: false,
                        oldPassword: '',
                        newPassword: '',
                        verifyNewPassword: ''
                    })
                }, 1500)
            }).catch(err => {
                this.setState({ errorMessage: getErrorMessage(err) })
                this.setState({ showErrorAlertResponse: true })
            })
    }

    componentDidMount() {
        this.setState({
            firstName: this.props.userDetail.first_name,
            lastName: this.props.userDetail.last_name
        })
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[PROFILE_USER_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="profile-settings">
                    <div className="header flex justify-between mb-5">
                        <div className="flex items-center">
                            <BackButton />
                            <p className="text-darkblue font-medium text-2xl">Pengaturan Profil</p>
                        </div>
                    </div>
                    <div className="calculate-layout-button">
                        <div className="bg-white rounded-2xl py-5 px-10 overflow-y-auto text-gray-600 h-full">
                            <CheckPermissionComponent permissionConstant={[PROFILE_USER_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <form onSubmit={this.handleChangeName} className="h-1/2 pb-3">
                                    <div className="flex border-2 border-gray-200 rounded-lg w-full h-full py-3 px-5 overflow-auto">
                                        <div className="w-1/3 relative">
                                            <p className="text-lg font-medium">Data Diri</p>
                                            <div className="w-4/5 pt-5">
                                                <label htmlFor="tslfirstname">Nama Depan</label>
                                                <input
                                                    type="text"
                                                    id="tslfirstname"
                                                    className="form-control"
                                                    placeholder="Tulis Nama Depan"
                                                    name="firstName"
                                                    value={this.state.firstName}
                                                    onChange={this.handleChange}
                                                    autoComplete="off"
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <div className="w-1/3 relative">
                                            <div className="w-4/5 pt-12">
                                                <label htmlFor="tsllastname">Nama Belakang</label>
                                                <input
                                                    type="text"
                                                    id="tsllastname"
                                                    className="form-control"
                                                    placeholder="Tulis Nama Belakang"
                                                    name="lastName"
                                                    value={this.state.lastName}
                                                    onChange={this.handleChange}
                                                    autoComplete="off"
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        {/* <div className="w-1/3 relative">
                                        <div className="absolute bottom-0 right-0">
                                            <button type="submit" id="btnsave" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-3">Simpan</button>
                                        </div>
                                    </div> */}
                                    </div>
                                </form>
                            </CheckPermissionComponent>
                            <CheckPermissionComponent permissionConstant={[PROFILE_CHANGE_PASSWORD_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                <form onSubmit={this.handleChangePassword} className="h-1/2 pt-3">
                                    <div className="flex border-2 border-gray-200 rounded-lg w-full h-full py-3 px-5 overflow-auto">
                                        <div className="w-1/3">
                                            <p className="text-lg font-medium">Keamanan & Privasi</p>
                                            <div className="w-4/5 pt-5">
                                                <label htmlFor="tsloldpassword">Kata Sandi</label>
                                                <div className="form-control flex items-center justify-between">
                                                    <input
                                                        type={this.state.showPassword1 ? "text" : "password"}
                                                        id="tsloldpassword"
                                                        placeholder="Tulis Kata Sandi"
                                                        className="custom-input w-4/5"
                                                        name="oldPassword"
                                                        value={this.state.oldPassword}
                                                        onChange={this.handleChange}
                                                        autoComplete="new-password"
                                                    />
                                                    <div>
                                                        {
                                                            this.state.showPassword1
                                                                ? <div id="btnshowpassword1" onClick={() => this.setState({ showPassword1: false })} className="cursor-pointer">
                                                                    <IconOpenedEye />
                                                                </div>
                                                                : <div id="btnshowpassword1" onClick={() => this.setState({ showPassword1: true })} className="cursor-pointer">
                                                                    <IconClosedEye />
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="w-1/3">
                                            <div className="w-4/5 pt-12">
                                                <label htmlFor="tslnewpassword">Kata Sandi Baru</label>
                                                <div className="form-control flex items-center justify-between">
                                                    <input
                                                        type={this.state.showPassword2 ? "text" : "password"}
                                                        id="tslnewpassword"
                                                        placeholder="Tulis Kata Sandi Baru"
                                                        className="custom-input w-4/5"
                                                        name="newPassword"
                                                        value={this.state.newPassword}
                                                        onChange={this.handleChange}
                                                        autoComplete="new-password"
                                                    />
                                                    <div>
                                                        {
                                                            this.state.showPassword2
                                                                ? <div id="btnshowpassword2" onClick={() => this.setState({ showPassword2: false })} className="cursor-pointer">
                                                                    <IconOpenedEye />
                                                                </div>
                                                                : <div id="btnshowpassword2" onClick={() => this.setState({ showPassword2: true })} className="cursor-pointer">
                                                                    <IconClosedEye />
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <p className="text-super-small">min. 8 karakter dan setidaknya mengandung huruf besar, angka dan simbol</p>
                                            <div className="w-4/5 pt-5">
                                                <label htmlFor="tslverifynewpassword">Konfirmasi Kata Sandi</label>
                                                <div className="form-control flex items-center justify-between">
                                                    <input
                                                        type={this.state.showPassword3 ? "text" : "password"}
                                                        id="tslverifynewpassword"
                                                        placeholder="Tulis Konfirmasi Kata Sandi"
                                                        className="custom-input w-4/5"
                                                        name="verifyNewPassword"
                                                        value={this.state.verifyNewPassword}
                                                        onChange={this.handleChange}
                                                        autoComplete="new-password"
                                                    />
                                                    <div>
                                                        {
                                                            this.state.showPassword3
                                                                ? <div id="btnshowpassword3" onClick={() => this.setState({ showPassword3: false })} className="cursor-pointer">
                                                                    <IconOpenedEye />
                                                                </div>
                                                                : <div id="btnshowpassword3" onClick={() => this.setState({ showPassword3: true })} className="cursor-pointer">
                                                                    <IconClosedEye />
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <p className="text-super-small">min. 8 karakter dan setidaknya mengandung huruf besar, angka dan simbol</p>
                                        </div>
                                        <div className="w-1/3 relative">
                                            <div className="absolute bottom-0 right-0">
                                                <button type="submit" id="btnsave" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-3">Simpan</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </CheckPermissionComponent>
                        </div>
                    </div>
                    <Alert show={this.state.showSuccessAlert1} icon="success" title="Berhasil Mengubah Nama Pengguna!" />
                    <Alert show={this.state.showSuccessAlert2} icon="success" title="Berhasil Mengubah Password!" />
                    <Alert show={this.state.showErrorAlert} icon="warning" title="Kata Sandi Lama Tidak Boleh Sama Dengan Kata Sandi Baru!" close={() => this.setState({ showErrorAlert: false })} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogin: (userDetail) => dispatch({ type: ActionType.UPDATE_PROFILE, payload: { userDetail } })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);